module.exports = __webpack_public_path__ + "static/media/enfase-mockup.4522b871.jpg";